'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  domain: '',
  search: {
    placeholder: 'Search'
  },
  menuToggle: {
    label: 'MENU'
  },
  logo: {
    href: '/'
  },
  mainBtn: [{
    text: 'CONTACT US',
    classes: 'btn-ghost hidden-xs gold',
    link: '/contact'
  }, {
    text: 'LOGIN',
    classes: 'btn-ghost hidden-xs concur-blue',
    link: ''
  }],
  siteLinks: [{
    title: {
      text: 'PRODUCTS'
    },
    list: [{
      text: 'Expense products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Expense',
        src: '/expense-management'
      }, {
        text: 'Concur Drive',
        src: '/concur-drive'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Audit Services',
        src: '/expense-audit'
      }, {
        text: 'Concur Request',
        src: '/travel-request'
      }, {
        text: 'Travel & Expense',
        src: '/travel-expense'
      }]
    }, {
      text: 'Travel products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Travel',
        src: '/travel-booking'
      }, {
        text: 'Concur Locate',
        src: '/concur-locate'
      }, {
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Concur Request',
        src: '/travel-request'
      }, {
        text: 'Concur TripLink',
        src: '/triplink'
      }]
    }, {
      text: 'Invoice products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Invoice',
        src: '/invoice-management'
      }]
    }, {
      text: 'Data insights',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Budget',
        src: '/budget-management'
      }, {
        text: 'Intelligence',
        src: '/business-intelligence'
      }, {
        text: 'Consultative Intelligence',
        src: '/travel-expense-data-analysis'
      }]
    }, {
      text: 'Support Offerings',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Service Administration',
        src: '/service-administration'
      }, {
        text: 'User Support Desk',
        src: '/user-support-desk'
      }, {
        text: 'Preferred Care',
        src: '/preferred-care'
      }]
    }, {
      text: 'Integrations',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'SAP',
        src: '/sap-integration'
      }, {
        text: 'Platform',
        src: '/concur-integrated-platform'
      }, {
        text: 'Concur TripLink',
        src: '/triplink'
      }, {
        text: 'App Centre',
        src: '/app-centre'
      }]
    }, {
      text: 'TMC Products',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Concur Compleat',
        src: '/tmc-solutions/compleat'
      }, {
        text: 'Concur Task Manager',
        src: '/tmc-solutions/task-manager'
      }, {
        text: 'Concur Trip Approval',
        src: '/tmc-solutions/trip-approval'
      }, {
        text: 'TravPay Hotel',
        src: '/tmc-solutions/travpay'
      }, {
        text: 'Traveler Self-Service',
        src: '/tmc-solutions/traveller-self-service'
      }, {
        text: 'TMC Solutions',
        src: '/tmc-solutions'
      }]
    }, {
      text: 'Contact Us',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'SOLUTIONS'
    },
    list: [{
      text: 'For small business',
      src: '/small-business'
    }, {
      text: 'For public sector',
      src: '/public-sector'
    }, {
      text: 'By industry',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Consumer products',
        src: '/consumer-products'
      }, {
        text: 'Energy and natural resources',
        src: '/energy-natural-resources'
      }, {
        text: 'Financial services',
        src: '/financial-services'
      }, {
        text: 'Service industries',
        src: '/service-industries'
      }, {
        text: 'Retail',
        src: '/retail'
      }, {
        text: 'Manufacturing',
        src: '/manufacturing'
      }, {
        text: 'All industries',
        src: '/industries'
      }]
    }, {
      text: 'By role',
      src: '',
      classes: 'sub-menu',
      subMenu: [{
        text: 'Enterprise Finance Leader',
        src: '/financial-manager-solutions'
      }, {
        text: 'Small Business Finance Leader',
        src: '/modern-finance-leaders'
      }, {
        text: 'IT Leader',
        src: '/IT-leader'
      }, {
        text: 'Travel Manager',
        src: '/travel-manager'
      }]
    }, {
      text: 'REQUEST PRICING',
      src: '/get-quote-form',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'ABOUT US'
    },
    list: [{
      text: 'Why SAP Concur',
      src: '/why-concur'
    }, {
      text: 'Our Platform',
      src: '/concur-integrated-platform'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'Executives',
      src: ''
    }, {
      text: 'Locations',
      src: '/contact/offices'
    }, {
      text: 'Corporate Social Responsibility',
      src: '/about/corporate-responsibility'
    }, {
      text: 'Careers',
      src: ''
    }, {
      text: 'Support',
      src: ''
    }, {
      text: 'CONTACT SALES',
      src: '/contact',
      classes: 'call-out'
    }]
  }, {
    title: {
      text: 'RESOURCES'
    },
    list: [{
      text: 'Newsroom',
      src: '/newsroom'
    }, {
      text: 'Resource Centre',
      src: '/resource-centre/index'
    }, {
      text: 'Events and Webinars',
      src: '/events'
    }, {
      text: 'Case Studies',
      src: '/casestudy'
    }, {
      text: 'Partners',
      src: '/partners'
    }, {
      text: 'App Centre',
      src: '/app-centre'
    }, {
      text: 'Privacy Policy',
      src: '/privacy-policy'
    }]
  }],
  supportLinks: [{
    text: 'LOGIN',
    href: ''
  }, {
    text: 'SERVICE STATUS',
    href: ''
  }, {
    text: 'CONTACT SALES',
    href: '/contact'
  }, {
    text: 'REQUEST A QUOTE',
    href: '/en-us/get-quote-form'
  }, {
    text: 'SUPPORT',
    href: ''
  }],
  mobileAppText: {
    text: 'GET CONCUR MOBILE APP'
  }
};